















































































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { User } from '@/data/models/user.model';
import FattorinoOfferList from './fattorino/FattorinoOfferList.vue';
import { OfferService } from '@/data/services/offer.service';
import { download } from '@/data/utils/helper';
import FattorinoRettifica from './fattorino/FattorinoRettifica.vue';
import { Rettifica } from '@/data/models/offer.model';
import FattorinoStats from './fattorino/FattorinoStats.vue';
import FattorinoStatsList from './fattorino/FattorinoStatsList.vue';

@Component
export default class FattorinoList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: () => [] }) selected!: User[];

	@Inject('CrudService') crudService!: CrudService<User>;
	@Inject('OfferService') offerService!: OfferService;

	rows: User[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('user');
	checkedRows: User[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadData() {
		this.rows = [];
		const datareq = this.crudService.searchEntities(
			User,
			'user',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			User,
			'user',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadData();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadData();
	}

	onCheck(checked: User[]) {
		this.$emit('update:selected', checked);
	}

	openOffers(row: User) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: FattorinoOfferList,
			hasModalCard: true,
			canCancel: false,
			width: 1280,
			props: {
				fattorino: row,
			},
			events: {
				positive: () => {
					modal.close();
				},
				negative: () => {
					modal.close();
				}
			}
		});
	}

	openRettifica(row: User) {
		const loading = this.$buefy.loading.open({});
		this.offerService.getRettifica(row.id).then(response => {
			const modal = this.$buefy.modal.open({
				parent: this,
				component: FattorinoRettifica,
				props: {
					model: response
				},
				hasModalCard: true,
				canCancel: false,
				events: {
					submit: (value: Rettifica) => {
						this.offerService.saveRettifica(row.id, value).then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							modal.close();
						}).catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
					}
				}
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());

	}

	printIncasso(row: User) {
		const loading = this.$buefy.loading.open({});
		this.offerService.printIncassoFattorino(row.id).then(response => {
			download(response, `incasso_fattorino_${row.id}.pdf`);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

	printPresaincarico(row: User) {
		const loading = this.$buefy.loading.open({});
		this.offerService.printPresaincarico(row.id).then(response => {
			download(response, `presaincarico_fattorino_${row.id}.pdf`);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

	printRimborso(row: User) {
		const loading = this.$buefy.loading.open({});
		this.offerService.printRimborsoFattorino(row.id).then(response => {
			download(response, `rimborso_fattorino_${row.id}.pdf`);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

	printStats(row: User) {
		this.$buefy.modal.open({
			parent: this,
			component: FattorinoStats,
			props: {
				fattorino: row
			},
			width: 300,
			hasModalCard: false,
			canCancel: false
		});
	}

	showStats(row: User) {
		this.$buefy.modal.open({
			parent: this,
			component: FattorinoStatsList,
			props: {
				fattorino: row
			},
			hasModalCard: false,
			canCancel: false
		});
	}

	deleteFattorino(item: User) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-fattorino-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(User, 'user', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.loadData();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			}
		});
	}

}
